<template>
  <!--This is for rows without subsections-->
	<v-container v-if="answers && (!row.subs || row.subs.length == 0)" grid-list-md>
		<v-flex xs12>
      <value-validation-message :qId="Number(qId)" :hasExp="hasExp" :subSectionIds="[ row.header, answers.answerCode, row.label ]" :answerIds="this.getAnswerIds(this.row)" :rowIndex="this.$vnode.key">
      </value-validation-message>
    </v-flex>
	<div style="width:100%" >
	<v-layout class="answers-row">
			<v-flex class="left-label" xs3>
				<header-cell
					v-if="row.isFakeSub != undefined"
					:isSub="true"
					:header="row.header"
					:label="row.label"
					:state="row.state"
					:question="row.question"
					:question-id="row.questionId"
					:answer-id="row.answerId"
					:cell-id="row.cellId"
					:help="row.help"
				></header-cell>
				<header-cell
					v-else
					:isSub="false"
					:header="row.header"
					:label="row.label"
					:state="row.state"
					:question="row.question"
					:question-id="row.questionId"
					:answer-id="row.answerId"
					:cell-id="row.cellId"
					:help="row.help"
					:hasDelete="isDynamic">
				</header-cell>
			</v-flex>
			<v-flex class="tb-width" v-for="(answer, index) in row.answers" :key="index" xs1>
				<!--Cells for user input-->
			<value-cell
					v-if="((index != row.answers.length - 1 || displayLayout == displayLayouts.J || displayLayout == displayLayouts.K || displayLayout == displayLayouts.I || displayLayout == displayLayouts.M)
								&& !((displayLayout == displayLayouts.G && rowIndex == myRows.length - 2) || (!isDynamic && rowIndex == myRows.length - 1) || row.label === 'Total' || row.answers[index].answerId == 'tot')
								)"
					:has-outline="hasOutline"
					:is-read-only="readOnly"
					:index="parseInt(index)"
					:name="answer.answerId"
					prefix="$"
					:id="qId"
					:value="answers[answer.answerId]"
					v-on:update="onUpdateRowAnswers"
					:rowLabel = "row.label"
				></value-cell>
				<!--Cells for row totals-->
				<computation-cell
					v-else-if="displayLayout != displayLayouts.M && (displayLayout != displayLayouts.J && (index == row.answers.length - 1 && row.label != 'Total')
											&& (displayLayout != displayLayouts.K) || (row.answers[index].answerId == 'tot' && row.label != 'Total'))"
					:id="qId"
					:name="answer.answerId"
					:index="parseInt(index)"
					:value="getRowTotal(row.answers.length-1,answers,rowIndex, null, parseInt(index))"
					v-on:update="onUpdateRowAnswers"
				></computation-cell>
				<!--Cells for column totals-->
			<computation-cell
					v-else-if= "(displayLayout == displayLayouts.G && rowIndex == myRows.length - 2) || rowIndex == myRows.length - 1 || row.label === 'Total'"
					:id="qId"
					:name="answer.answerId"
					:index="parseInt(index)"
					:value="getColumnTotal(myRows.length-1,answers,index, rowIndex, answer.answerId)"
					v-on:update="onUpdateRowAnswers"
					v-on:update:disable="$emit('update:disable', true)"
					:disabled="isNA"
				></computation-cell>
			</v-flex>
	</v-layout>
	</div>
  </v-container>

  <!--This is for rows with subsections-->
  <v-container v-else grid-list-md>
    <v-layout>
      <v-flex class="left-label" xs3>
        <header-cell
          :isSub="false"
          :header="row.header"
          :label="row.label"
          :question="row.question"
          :question-id="row.questionId"
          :answer-id="row.answerId"
          :cell-id="row.cellId"
        ></header-cell>
      </v-flex>
    </v-layout>
		<div v-for="(row1, index1) in row.subs" :key="index1">
			<v-flex xs12>
				<value-validation-message :qId="Number(qId)" :hasExp="hasExp" :subSectionIds="[row.header, row1.header, answers.answerCode, row.label, row1.label]" :answerIds="getAnswerIds(row1)" :rowIndex="index1"></value-validation-message>
			</v-flex>
			<v-layout class="answers-row">
				<v-flex class="left-label" xs3>
					<header-cell
						:isSub="true"
						:header="row1.header"
						:label="row1.label"
						:question="row1.question"
						:question-id="row1.questionId"
						:answer-id="row1.answerId"
						:cell-id="row1.cellId"
						:class="'marginleft'"
					></header-cell>
				</v-flex>
				<v-flex class="tb-width" v-for="(answer, index) in row1.answers" :key="index" xs1>
					<value-cell
						v-if="(displayLayout == displayLayouts.J)
									|| ((index != row1.answers.length - 1 || displayLayout == displayLayouts.K) && (index1 != row.subs.length-1 || row.subs[0].isFakeSub != undefined))"
						:has-outline="hasOutline"
						:is-read-only="readOnly"
						:index="parseInt(index)"
						:name="answer.answerId"
						:subHeader="row1.label"
            		:id="qId"
						prefix="$"
						:value="answers[answer.answerId]"
						v-on:update="onUpdateRowAnswers"
					></value-cell>
					<computation-cell
						v-else-if="index == row1.answers.length - 1 && displayLayout != displayLayouts.K"
						:id="qId"
						:name="answer.answerId"
						:index="parseInt(index)"
						:subHeader="row1.label"
						:value="getRowTotal(row1.answers.length-1,answers,rowIndex, index1)"
						v-on:update="onUpdateRowAnswers"
					></computation-cell>
					<computation-cell
						v-if="(index != row1.answers.length - 1 && displayLayout != displayLayouts.J || (index1 == row.subs.length - 1 && displayLayout == displayLayouts.K)) && index1 == row.subs.length - 1 && row.subs[0].isFakeSub == undefined"
						:id="qId"
						:name="answer.answerId"
						:index="parseInt(index)"
						:subHeader="row1.label"
						:value="getColumnTotal(row.subs.length-1,answers,rowIndex, index1, answer.answerId)"
						v-on:update="onUpdateRowAnswers"
					></computation-cell>
				</v-flex>
			</v-layout>
		</div>
  </v-container>
</template>

<script>
import { utilityService } from '../../services/utilityService';
import { CONSTANTS } from './../../common/constants';
export default {
  name: 'AnswersRow',
  props: {
    row: Object,
    qId: String,
    answers: Object,
    myRows: Array,
    qColumns: Array,
    fullAnswer: Object,
    fullAnswerArray: Array,
    isDynamic: Boolean,
    displayLayout: Number,
		displayLayouts: Object,
		hasExp: Boolean,
		isNA: Boolean
  },
  data: () => ({
    theValue: undefined,
    hasOutline: false,
    readOnly: false,
    rowIndex: null,
    qColumnsLength: 0
  }),
  mounted () {
    this.theValue = this.value;
  },
  computed: {
    sectionAnswers: function () {
      return this.$store.getters['answersArray'][this.qId];
		}
  },
  created () {
    const me = this;
    me.rowIndex = this.$vnode.key;
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'saveAnswer' && me.id === mutation.payload.id) {
        let total = 0;
        const val = mutation.payload.value;
        if (val && me.fields && me.fields.length > 0) {
          me.fields.forEach(field => {
            let fieldVal = val[field];
            if (typeof val[field] === 'string') {
              fieldVal = utilityService.convertStringToNum(fieldVal);
            }
            total += fieldVal;
          });
          this.theValue = utilityService.addCurrencyCommas(total.toString());
        }
      }
    });
  },
  methods: {
    onUpdateRowAnswers (evt) {
				const layout = this.displayLayout;
				const layouts = this.displayLayouts;
				// --- Case 1: Layout D (simple emit) ---
				if (layout === layouts.D) {
					this.$emit('update', {
						value: evt.value,
						questionId: this.row.header,
						answerId: evt.answerId
					});
					return;
				}
				// --- Case 2: Layouts A, C, I, N ---
				if ([layouts.A, layouts.C, layouts.I, layouts.N].includes(layout)) {
					let identifierName;
					// Layout I has special logic
				if (layout === layouts.I) {
					const isTotalRow =
						this.row.label === CONSTANTS.LAYOUT_I_STATIC_ROW_NAMES.TOTAL;

						identifierName = isTotalRow
							? this.answers.orgCod
							: this.row.header;
				} else {
					// Other layouts: find the first key containing "id"
					const idKey = Object.keys(this.answers).find(
						key => key.toLowerCase().includes('id')
					);
					identifierName = this.answers[idKey];
				}
					this.$emit('update', {
						value: evt.value,
						questionEntryId: identifierName,
						answerId: evt.answerId,
						approxIndex: 0
					});
					return;
				}
					// --- Fallback: emit event as-is ---
					this.$emit('update', evt);
			},
    getColumnTotal (numRows, answer, index, subIndex, name) {
		let sum = 0;
		const layout = this.displayLayout;
		const layouts = this.displayLayouts;

		// Helper: safe numeric read
		const read = (obj, key) => {
			if (!obj || obj[key] == null || obj[key] === "") { return 0; }
			return Number(obj[key]);
		};

		// Helper: find column index
		const findColumnIndex = (row, id) => {
			if (!row || !row.answers) return -1;
			return row.answers.findIndex(a => a.answerId === id);
		};

		// -------------------------------------------------------
		// CASE 1 — Layout D: last row = sum of section totals
		// -------------------------------------------------------
		if (layout === layouts.D && this.rowIndex + 1 === this.myRows.length) {
			for (let i = 0; i < this.myRows.length - 1; i++) {
				const row = this.myRows[i];
				const section = this.fullAnswer[row.header];

				if (row.subs) {
					const last = row.subs.length - 1;
					const id = row.subs[last].answers[index].answerId;
					sum += read(section, id);
				} else {
					const id = row.answers[index].answerId;
					sum += read(section, id);
				}
			}
			return sum;
		}

		// -------------------------------------------------------
		// CASE 2 — Layout G: special last two rows
		// -------------------------------------------------------
		if (layout === layouts.G) {
			const colIndex = findColumnIndex(this.myRows[subIndex], name);

			// second-to-last row
			if (this.rowIndex + 2 === this.myRows.length) {
				for (let i = 2; i < numRows - 1; i++) {
					const id = this.myRows[i].answers[colIndex].answerId;
					sum += read(answer, id);
				}
				return sum;
			}

			// last row
			if (this.rowIndex + 1 === this.myRows.length) {
				for (let i = 0; i < numRows - 1; i++) {
					const id = this.myRows[i].answers[colIndex].answerId;
					sum += read(answer, id);
				}
				return sum;
			}
		}

		// -------------------------------------------------------
		// CASE 3 — Row has subsections
		// -------------------------------------------------------
		if (this.row.subs) {
			const colIndex = findColumnIndex(this.row.subs[subIndex], name);
			for (let i = 0; i < numRows; i++) {
				const id = this.row.subs[i].answers[colIndex].answerId;
				sum += read(answer, id);
			}
			return sum;
		}

		// -------------------------------------------------------
		// CASE 4 — Layout I special rule
		// -------------------------------------------------------
		const colIndex = findColumnIndex(this.myRows[subIndex], name);

		if (layout === layouts.I) {
			for (let i = 0; i < this.sectionAnswers.length; i++) {
				if (i === 0) {
					if (this.sectionAnswers[i][name] === Number.MIN_SAFE_INTEGER) {
						return Number.MIN_SAFE_INTEGER;
					}
					continue;
				}
				sum += read(this.sectionAnswers[i], name);
			}
			return sum;
		}

		// -------------------------------------------------------
		// CASE 5 — Layout J (reactive totals)
		// -------------------------------------------------------
		if (layout === layouts.J) {
			// Skip row 0 (header) and last row (TOTAL)
			for (let i = 1; i < this.myRows.length - 1; i++) {
				const row = this.myRows[i];

				// ⭐ Use LIVE data, not fullAnswer snapshot
				const section = this.sectionAnswers?.[i] || answer || {};

				if (row.subs) {
					// Sum ALL subsections
					for (let s = 0; s < row.subs.length; s++) {
						const id = row.subs[s].answers[index].answerId;
						sum += read(section, id);
					}
				} else {
					const id = row.answers[index].answerId;
					sum += read(section, id);
				}
			}
			return sum; // MUST return here
		}

		// -------------------------------------------------------
		// FALLBACK — all other layouts
		// -------------------------------------------------------
		for (let i = 0; i < numRows; i++) {
			// Layouts A, C, N use sectionAnswers
			if (layout === layouts.A || layout === layouts.C || layout === layouts.N) {
				sum += read(this.sectionAnswers[i], name);
				continue;
			}

			if (layout === layouts.M) {
				const rowLabel = this.myRows[i]?.label?.toLowerCase().trim();

				// Skip row f — it's the total row itself (prevents circular)
				if (rowLabel === "total r&d conduct and r&d plant") continue;

				// Skip row d — it's subtotal of a+b+c (prevents double count)
				if (rowLabel === "total r&d conduct") continue;

				// Sum rows a, b, c, e only
				const id = this.myRows[i].answers[colIndex].answerId;
				sum += read(answer, id);
				continue; // ← MUST have this — stops fall-through to default
			}
			// Rows with subs: use last subsection total
			if (this.myRows[i].subs) {
				const last = this.myRows[i].subs.length - 1;
				const id = this.myRows[i].subs[last].answers[colIndex].answerId;
				sum += read(answer, id);
				continue;
			}

			// Default case
			const id = this.myRows[i].answers[colIndex].answerId;
			sum += read(answer, id);
		}
		return sum;
	},
    getRowTotal (numColumns, answer, index, subIndex, totIndex) {
		let sum = 0;
		// --- Layout I logic ---
		if (this.displayLayout === this.displayLayouts.I) {
			const arr = this.row.answers || [];
				for (let i = 0; i < totIndex && i < arr.length; i++) {
					const id = arr[i].answerId; sum += Number(answer[id] || 0);
				}
				return sum;
		}
		// --- Other layouts ---
		let arr;
		if (subIndex == null) {
			arr = this.row.answers || [];
		} else {
			arr = (this.row.subs && this.row.subs[subIndex] &&
				this.row.subs[subIndex].answers)
			? this.row.subs[subIndex].answers
			: [];
		}
		// Sum all except last column
		const limit = arr.length - 1;
		for (let i = 0; i < limit; i++) {
			const id = arr[i].answerId;
			sum += Number(answer[id] || 0);
		}
		return sum;
	},
	getAnswerIds: function (row) {
    if (!row || !Array.isArray(row.answers)) { return []; }
		return row.answers.map(a => a.answerId);
	}
  }
};
</script>

<style scoped>
.row-header {
  font-weight: bold;
  color: #13314f;
}
.marginleft {
  margin-left: 0%;
}
.tb-width {
  min-width: 150px;
}
.left-label {
   margin-top: 17px;
   min-width: 450px;
}

/* hover effect on answer rows.  TODO: not show hover effect on rows that are all totals */
div.layout.answers-row:hover {
  border-radius: 5px;
	/*background-color: #848FA2;*/
}

</style>
